function setCookie(name, value, days) {
  var expires = "";
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

(function () {
  const customize_button = document.querySelector(".open-configurateur");

  function generateRandomString(length) {
    let result = '';
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    for (let i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }

  // Ajouter le paramètre aléatoire à l'URL
  const randomString = generateRandomString(8);

  if (customize_button) {
    customize_button.addEventListener("click", (e) => {
      e.preventDefault();

      if (typeof p_obj === "undefined" || !p_obj || !p_obj.ref_profil ||
          typeof CONFIGURATOR === "undefined") {
        console.error(
          "[configurateur] p_obj/CONFIGURATOR non initialisé. Vérifier : " +
          "(a) le metafield profils du produit, " +
          "(b) les champs du metaobject format (tarif_profil, nb_client_mockups_preview, " +
          "nom_des_pages renseignés, imposition_<A4|A3|SRA3> cohérent avec le profil). " +
          "Voir les warnings [configurateur:format=...] plus haut dans la console."
        );
        alert(
          "Configurateur indisponible : le format de ce produit est incomplet " +
          "ou le profil est incompatible. Vérifiez les champs du metaobject format " +
          "dans Shopify admin (voir console pour le détail)."
        );
        return;
      }

      setTimeout(function () {
        window.location.href =
          window.location.pathname +
          "?ref_profil=" +
          p_obj.ref_profil +
          "&view=configurator&data=" +
          encodeURIComponent(btoa(JSON.stringify(CONFIGURATOR))) + "&cached=" + randomString + "&page=1";
      }, 1000);
    });
  }
})();

class WProductTemplate extends HTMLElement {
  constructor() {
    super();
    this.initEvents();

    //this.initProduct(metafields_products)
  }

  initEvents() {
    this.querySelectorAll(".drawer-button").forEach((button) => {
      button.addEventListener("click", this.openDrawer.bind(this));
    });

    document.addEventListener(
      "click",
      function (e) {
        if (
          !e.target.closest(".drawer-button") &&
          !e.target.closest(".drawer-custom__product") && !e.target.closest('cart-drawer')
        ) {
          this.closeDrawer();
        }
      }.bind(this)
    );

    document.querySelectorAll(".close-drawer").forEach((close) => {
      close.addEventListener("click", this.closeDrawer.bind(this));
    });
  }

  initProduct(configJson) {
    let selectCut = document.querySelector(
      "product-drawer-decoupe .drawer--list"
    );

    for (let i = 0; i < configJson.format.ref_cut.length; i++) {
      let option = document.createElement("div");
      option.dataset.value = i;
      option.textContent = configJson.format.name_cut[i];
      selectCut.appendChild(option);
    }

    let selectColor = document.querySelector(
      "product-drawer-couleur .drawer--list"
    );

    for (let i = 0; i < configJson.theme_colors.ref_color.length; i++) {
      let option = document.createElement("div");
      option.dataset.value = configJson.theme_colors.ref_color[i];
      let bubble = document.createElement("span");
      bubble.style.backgroundColor = configJson.theme_colors.hexa_color[i];
      option.textContent = configJson.theme_colors.name_color[i];
      option.appendChild(bubble);
      selectColor.appendChild(option);
    }
  }

  openDrawer(e) {
    let currentDrawer = e.currentTarget.dataset.id;
    const drawer = document.querySelector(`product-drawer-${currentDrawer}`);
    if (!drawer) {
      console.warn(
        `[configurateur] no <product-drawer-${currentDrawer}> in DOM — button shown without a matching drawer`
      );
      return;
    }
    drawer.classList.add("open-drawer");
    document.body.classList.add("overflow-hidden");
    document.querySelector(".overlay.js-overlay")?.classList.add("is-visible");
  }

  closeDrawer() {
    const openDrawers = document.querySelectorAll(".drawer-custom__product.open-drawer");
    // Runs on every document click: with no options drawer open, leave the page
    // overlay and scroll lock to whichever component set them (mega menu, sidebars).
    if (!openDrawers.length) return;
    console.log("CLOSE");
    openDrawers.forEach((drawer) => {
      drawer.classList.remove("open-drawer");
    });
    document.body.classList.remove("overflow-hidden");
    document.querySelector(".overlay.js-overlay").classList.remove("is-visible");
  }
}

customElements.define("w-product-template", WProductTemplate);
